import { render, staticRenderFns } from "./role-management.vue?vue&type=template&id=af5a852e&scoped=true"
import script from "./role-management.vue?vue&type=script&lang=js"
export * from "./role-management.vue?vue&type=script&lang=js"
import style0 from "./role-management.vue?vue&type=style&index=0&id=af5a852e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5a852e",
  null
  
)

export default component.exports